import { Component, OnInit } from '@angular/core';
import frenchi18n from '@assets/i18n/fr.json';
import { ProcessEventFactory } from '@shared/models/processEvents';
import { ProcessEventService } from '@shared/services/process-event.service';
import { TrackerService } from '@shared/services/tracker.service';

@Component({
  selector: 'app-bank-connection-failure-retry',
  templateUrl: './bank-connection-failure-retry.html',
  styleUrls: [
    '../../../../shared/css/oney-bottom-skew-container.scss',
    './bank-connection-failure-retry.scss',
  ],
  // eslint-disable-next-line @angular-eslint/no-host-metadata-property
  host: { class: 'max-w-full d-flex flex-col justify-center items-center' },
})
export class BankConnectionFailureRetryComponent implements OnInit {
  isPopinOpen = false;

  constructor(
    private processEventService: ProcessEventService,
    private tracker: TrackerService
  ) {}
  ngOnInit(): void {
    this.tracker.trackPage({
      taggingPage: 'BANK_CONNECTION_FAILURE_RETRY',
    });
  }

  retryBankConnectionWithOpenBanking() {
    this.tracker.trackClick({
      click: frenchi18n.common_retry,
      taggingPage: 'BANK_CONNECTION_FAILURE_RETRY',
    });

    this.processEventService.push(ProcessEventFactory.SpawnRetryWebauth());
  }

  retryBankConnectionWithPartner() {
    this.tracker.trackClick({
      click: frenchi18n.common_enterInformationManually,
      taggingPage: 'BANK_CONNECTION_FAILURE_RETRY',
    });

    this.isPopinOpen = true;
  }
  abandon() {
    this.processEventService.push(ProcessEventFactory.SpawnAbandonEvent());
  }
  closePopin() {
    this.isPopinOpen = false;
  }
}
